import styled from 'styled-components'

interface IAccordionStyles {
  isOpen: boolean
}

export const TimelineAccordionContainer = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
`

interface SectionProps {
  marginTop?: number
}

export const Section = styled.div<SectionProps>`
  position: relative;
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px`};
`

export const TimelineAccordionTitle = styled.button<IAccordionStyles>`
  padding: 3px 3px 3px 5px;
  width: fit-content;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
  transition: background-color 100ms ease-in-out;

  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  color: ${props => props.theme.colors.color005597};

  svg {
    transform: translateY(-1px) ${props => (props.isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
    fill: ${props => props.theme.colors.color545e6c};
    width: 7px;

    g {
      clip-path: none;
    }
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  &:active {
    background: rgba(0, 0, 0, 0.15);
  }
  &:focus-visible {
    border: 1px solid rgba(0, 0, 0, 0.3);
    outline: none;
  }
`

export const Ellipse = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  &.spaced-from-border {
    position: relative;
    top: 6px;
    left: 2px;
  }
  &.outlined {
    border: 1px solid ${props => props.theme.colors.color378ff7};
    background: ${({ theme }) => theme.zds.colors.neutral1000};
  }

  &.filled {
    background: ${props => props.theme.colors.color005597};
  }
`

export const VerticalLine = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: calc(100% + 5px);
  transform: translateX(-50%);

  background: ${props => props.theme.colors.color378ff7};
`

export const TimelineAccordionContent = styled.div<IAccordionStyles>`
  position: relative;
  height: ${props => (props.isOpen ? '100%' : '0')};
  overflow: ${props => (props.isOpen ? 'visible' : 'hidden')};

  transition: height 300ms ease-in-out;
  animation-delay: 300ms;
  animation: ${props => (props.isOpen ? 'collapse' : 'expand')} 0s ease-in-out;
  @keyframes collapse {
    0% {
      max-height: 100%;
      opacity: 1;
    }
    100% {
      max-height: 0px;
      opacity: 0;
    }
  }
  @keyframes expand {
    0% {
      max-height: 0px;
      opacity: 0;
    }
    100% {
      max-height: 100%;
      opacity: 1;
    }
  }
`
